import { memo } from 'react';
import type { VoidFunctionComponent } from 'react';

import BowerIcon from './BowerIcon';
import CargoIcon from './CargoIcon';
import CocoapodsIcon from './CocoapodsIcon';
import CpanIcon from './CpanIcon';
import DebianIcon from './DebianIcon';
import FallbackIcon from './FallbackIcon';
import GitIcon from './GitIcon';
import GoIcon from './GoIcon';
import MavenIcon from './MavenIcon';
import NpmIcon from './NpmIcon';
import NugetIcon from './NugetIcon';
import PipIcon from './PipIcon';
import PubIcon from './PubIcon';
import RubygemsIcon from './RubygemsIcon';
import SwiftIcon from './SwiftIcon';

type Props = {
  fetcher: string;
  isSmallIcon?: boolean;
};

const FetcherIcon: VoidFunctionComponent<Props> = ({ fetcher, isSmallIcon }) => {
  switch (fetcher) {
    case 'bower': return <BowerIcon isSmallIcon={isSmallIcon} />;
    case 'cargo': return <CargoIcon isSmallIcon={isSmallIcon} />;
    case 'cpan': return <CpanIcon isSmallIcon={isSmallIcon} />;
    case 'deb': return <DebianIcon isSmallIcon={isSmallIcon} />;
    case 'gem': return <RubygemsIcon isSmallIcon={isSmallIcon} />;
    case 'git': return <GitIcon isSmallIcon={isSmallIcon} />;
    case 'go': return <GoIcon isSmallIcon={isSmallIcon} />;
    case 'mvn': return <MavenIcon isSmallIcon={isSmallIcon} />;
    case 'npm': return <NpmIcon isSmallIcon={isSmallIcon} />;
    case 'nuget': return <NugetIcon isSmallIcon={isSmallIcon} />;
    case 'pip': return <PipIcon isSmallIcon={isSmallIcon} />;
    case 'pod': return <CocoapodsIcon isSmallIcon={isSmallIcon} />;
    case 'pub': return <PubIcon isSmallIcon={isSmallIcon} />;
    case 'swift': return <SwiftIcon isSmallIcon={isSmallIcon} />;
    default: return <FallbackIcon isSmallIcon={isSmallIcon} />;
  }
};

export default memo(FetcherIcon);
